import {useMutation, UseMutationResult} from '@tanstack/react-query';
import creatorsUpdaters from '@/api/updaters/creators';

export type BulkThreadsResponse = {
  jobId: string;
  total: number;
};

function useBulkThreads(): UseMutationResult<
  BulkThreadsResponse,
  Error,
  {
    agencyId: string;
    brandId: string;
    creatorIds: string[];
    initialMessage: string;
  }
> {
  return useMutation({
    mutationKey: ['creators', 'bulkThreads'],
    mutationFn: creatorsUpdaters.bulkThreads,
  });
}

export default useBulkThreads;
